import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import Login from '../pages/Login';
import Page404 from '../pages/Page404';
import Page403 from '../pages/Page403';
import Users from '../pages/Users';
import User from '../pages/Users/User';
import UserProfile from '../pages/Users/UserProfile';
import UserCompany from '../pages/Users/UserCompany';
import Companies from '../pages/Companies';
import Company from '../pages/Companies/Company';
import AccessCompany from '../pages/Companies/AccessCompany';
import Accesses from '../pages/Accesses';
import Access from '../pages/Accesses/Access';
import AccessModule from '../pages/Accesses/AccessModule';
import AccessUser from '../pages/Users/AccessUser';
import Channels from '../pages/Channels';
import Channel from '../pages/Channels/Channel';
import Classifiers from '../pages/Classifiers';
import Classifier from '../pages/Classifiers/Classifier';
import Customers from '../pages/Customers';
import Customer from '../pages/Customers/Customer';
import Leads from '../pages/Leads';
import Lead from '../pages/Leads/Lead';
import Home from '../pages/Home';
import EmailProvider from '../pages/EmailProvider/EmailProvider';
import EmailsProviders from '../pages/EmailProvider';
import ResetPassword from '../pages/Login/ResetPassword';
import WhatsAppProvider from '../pages/WhatsAppProvider/WhatsAppProvider';
import WhatsAppProviders from '../pages/WhatsAppProvider';
import ContractualDiscount from '../pages/ContractualDiscounts/ContractualDiscount';
import ContractualDiscounts from '../pages/ContractualDiscounts';
import PaymentMethods from '../pages/PaymentMethods';
import PaymentMethod from '../pages/PaymentMethods/PaymentMethod';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/resetpassword" element={<ResetPassword />} />
      <Route path="/404" element={<Page404 />} />
      <Route path="/403" element={<Page403 />} />
      <Route path="*" element={<Navigate to="/404" />} />
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/" element={<Home />} />
      </Route>
      <Route path="/users" element={<PrivateRoute />}>
        <Route path="/users" element={<Users />} />
      </Route>
      <Route path="/users/:id/edit" element={<PrivateRoute />}>
        <Route path="/users/:id/edit" element={<User />} />
      </Route>
      <Route path="/users/:id/company" element={<PrivateRoute />}>
        <Route path="/users/:id/company" element={<UserCompany />} />
      </Route>
      <Route path="/users/:id/access" element={<PrivateRoute />}>
        <Route path="/users/:id/access" element={<AccessUser />} />
      </Route>
      <Route path="/users/:id/profile" element={<PrivateRoute />}>
        <Route path="/users/:id/profile" element={<UserProfile />} />
      </Route>
      <Route path="/users/new" element={<PrivateRoute />}>
        <Route path="/users/new" element={<User />} />
      </Route>
      <Route path="/profile/:id" element={<PrivateRoute />}>
        <Route path="/profile/:id" element={<UserProfile />} />
      </Route>
      <Route path="/companies" element={<PrivateRoute />}>
        <Route path="/companies" element={<Companies />} />
      </Route>
      <Route path="/companies/:id/edit" element={<PrivateRoute />}>
        <Route path="/companies/:id/edit" element={<Company />} />
      </Route>
      <Route path="/companies/:id/access" element={<PrivateRoute />}>
        <Route path="/companies/:id/access" element={<AccessCompany />} />
      </Route>
      <Route path="/companies/new" element={<PrivateRoute />}>
        <Route path="/companies/new" element={<Company />} />
      </Route>
      <Route path="/accesses" element={<PrivateRoute />}>
        <Route path="/accesses" element={<Accesses />} />
      </Route>
      <Route path="/accesses/:id/edit" element={<PrivateRoute />}>
        <Route path="/accesses/:id/edit" element={<Access />} />
      </Route>
      <Route path="/accesses/:id/module" element={<PrivateRoute />}>
        <Route path="/accesses/:id/module" element={<AccessModule />} />
      </Route>
      <Route path="/accesses/new" element={<PrivateRoute />}>
        <Route path="/accesses/new" element={<Access />} />
      </Route>
      <Route path="/channels/" element={<PrivateRoute />}>
        <Route path="/channels/" element={<Channels />} />
      </Route>
      <Route path="/channels/new" element={<PrivateRoute />}>
        <Route path="/channels/new" element={<Channel />} />
      </Route>
      <Route path="/channels/:id/edit" element={<PrivateRoute />}>
        <Route path="/channels/:id/edit" element={<Channel />} />
      </Route>
      <Route path="/classifiers" element={<PrivateRoute />}>
        <Route path="/classifiers" element={<Classifiers />} />
      </Route>
      <Route path="/classifiers/new" element={<PrivateRoute />}>
        <Route path="/classifiers/new" element={<Classifier />} />
      </Route>
      <Route path="/classifiers/:id/edit" element={<PrivateRoute />}>
        <Route path="/classifiers/:id/edit" element={<Classifier />} />
      </Route>
      <Route path="/customers" element={<PrivateRoute />}>
        <Route path="/customers" element={<Customers />} />
      </Route>
      <Route path="/customers/new" element={<PrivateRoute />}>
        <Route path="/customers/new" element={<Customer />} />
      </Route>
      <Route path="/customers/:id/edit" element={<PrivateRoute />}>
        <Route path="/customers/:id/edit" element={<Customer />} />
      </Route>
      <Route path="/leads" element={<PrivateRoute />}>
        <Route path="/leads" element={<Leads />} />
      </Route>
      <Route path="/leads/new" element={<PrivateRoute />}>
        <Route path="/leads/new" element={<Lead />} />
      </Route>
      <Route path="/leads/:id/edit" element={<PrivateRoute />}>
        <Route path="/leads/:id/edit" element={<Lead />} />
      </Route>
      <Route path="/emailsproviders" element={<PrivateRoute />}>
        <Route path="/emailsproviders" element={<EmailsProviders />} />
      </Route>
      <Route path="/emailsproviders/new" element={<PrivateRoute />}>
        <Route path="/emailsproviders/new" element={<EmailProvider />} />
      </Route>
      <Route path="/emailsproviders/:id/edit" element={<PrivateRoute />}>
        <Route path="/emailsproviders/:id/edit" element={<EmailProvider />} />
      </Route>
      <Route path="/whatsappproviders" element={<PrivateRoute />}>
        <Route path="/whatsappproviders" element={<WhatsAppProviders />} />
      </Route>
      <Route path="/whatsappproviders/new" element={<PrivateRoute />}>
        <Route path="/whatsappproviders/new" element={<WhatsAppProvider />} />
      </Route>
      <Route path="/whatsappproviders/:id/edit" element={<PrivateRoute />}>
        <Route
          path="/whatsappproviders/:id/edit"
          element={<WhatsAppProvider />}
        />
      </Route>
      <Route path="/discounts" element={<PrivateRoute />}>
        <Route path="/discounts" element={<ContractualDiscounts />} />
      </Route>
      <Route path="/discounts/new" element={<PrivateRoute />}>
        <Route path="/discounts/new" element={<ContractualDiscount />} />
      </Route>
      <Route path="/discounts/:id/edit" element={<PrivateRoute />}>
        <Route path="/discounts/:id/edit" element={<ContractualDiscount />} />
      </Route>
      <Route path="/paymentmethods" element={<PrivateRoute />}>
        <Route path="/paymentmethods" element={<PaymentMethods />} />
      </Route>
      <Route path="/paymentmethods/new" element={<PrivateRoute />}>
        <Route path="/paymentmethods/new" element={<PaymentMethod />} />
      </Route>
      <Route path="/paymentmethods/:id/edit" element={<PrivateRoute />}>
        <Route path="/paymentmethods/:id/edit" element={<PaymentMethod />} />
      </Route>
    </Routes>
  );
}
